import PageSEO from '@/components/base/PageSEO';
import HeroSection from './components/HeroSection';
import CategoryNav from './components/CategoryNav';
import HotDealsSection from './components/HotDealsSection';
import LatestArticles from './components/LatestArticles';
import FAQSection from './components/FAQSection';

export default function Home() {
  const schemaJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '福利铺子',
    url: 'https://fulipuzi.com',
    description: '福利铺子是您发现好物优惠、专属福利与超值折扣的首选平台。每天精选海量福利资源，涵盖购物返现、限时秒杀、会员特权等。',
    potentialAction: {
      '@type': 'SearchAction',
      target: 'https://fulipuzi.com/search?q={search_term_string}',
      'query-input': 'required name=search_term_string',
    },
  };

  return (
    <>
      <PageSEO
        title="福利铺子 - 海量福利优惠一站汇聚"
        description="福利铺子是您发现好物优惠、专属福利与超值折扣的首选平台。每天精选海量福利资源，涵盖购物返现、限时秒杀、会员特权等，让您轻松享受实实在在的省钱福利。关注福利铺子，好福利不错过！"
        keywords="福利铺子,福利铺子优惠,福利铺子好物推荐,每日福利折扣,限时秒杀福利,会员专属福利,购物省钱攻略"
        canonicalUrl="https://fulipuzi.com"
        ogType="website"
        schemaJsonLd={schemaJsonLd}
      />
      <HeroSection />
      <CategoryNav />
      <HotDealsSection />
      <LatestArticles />
      <FAQSection />
    </>
  );
}